export const environment = {
    production: true,
    hmr: false,
    VERSION: 'v' + require('../../../../package.json').version
};
